import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  margin: 0 16px;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 12px;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  border: none;
  outline: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  box-shadow: none;

  &:focus {
    box-shadow: none;
    border: none;
    outline: none;
  }
`;

export const SuggestionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const SuggestionItem = styled.div`
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;

  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
`;
